// src/components/Admin/navigation.js

import React, { useState } from 'react';
import { FaBars, FaUserCircle } from "react-icons/fa"; // ✅ Import both icons
import ProfileModal from './profilemodal';

const Navbar = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <nav className="admin-navbar">
      {/* Left-aligned menu (hamburger) icon */}
      <div className="nav-icons">
        <FaBars className="bars-icon" />
      </div>

      {/* Right-aligned user profile icon */}
      <FaUserCircle className="user-icon" onClick={handleShow} />

      {/* Profile Modal */}
      <ProfileModal show={show} handleClose={handleClose} />
    </nav>
  );
};

export default Navbar;